import React, { useEffect } from 'react';
import { NewModal as Modal, Checkbox, CheckboxGroup, themes } from '@digitools/honest-react';
import { useDisclosure } from '@mantine/hooks';
import { useNavigate } from 'react-router-dom';
import useTranslate from '../../../hooks/useTranslate';
import { EoiGeneralText } from '../i18n/EoiText';
/**
 * Isolated in its own memoized component so unrelated state changes in EoiInterviewContainer
 * (e.g. initialInformation/legalText updates on AdditionalInfoForm submit) don't re-render this modal.
 */
const EmployerConfirmationModal = ({ shouldShow, customerName }) => {
    const { t } = useTranslate();
    const navigate = useNavigate();
    const [isOpen, { open, close }] = useDisclosure(false);
    useEffect(() => {
        if (shouldShow) {
            open();
        }
    }, [shouldShow]);
    if (!shouldShow) {
        return null;
    }
    return (<Modal closeOnClickOutside={true} opened={isOpen} centered={true} title={t(EoiGeneralText.confirmEmployer)} size={'680px'} onClose={() => {
            close();
            navigate('/employee/home');
        }} cancelButtonText={t({ english: 'Close', spanish: 'Cerca' })} cancelButtonProps={{
            as: 'a',
            href: '/customer/employee/home',
            'data-testid': 'close-employer-modal-button',
            buttonType: 'secondary',
        }} submitButtonText={t({ english: 'Confirm', spanish: 'Confirmar' })} submitButtonProps={{
            'data-testid': 'confirm-employer-modal-button',
            buttonType: 'primary',
        }} onSubmit={() => close()} isForm={true} formProps={{ 'data-testid': 'employer-confirm-form' }} theme={themes.lincoln}>
      <p>{t(EoiGeneralText.protectInfo)}</p>
      <p>
        <CheckboxGroup required={true} field={'protectInfo'} label={''} hideLabel={true} validate={(value) => !value || value.length < 1
            ? t({ english: 'Please confirm your employer to continue.', spanish: 'Confirme su empleador para continuar.' })
            : undefined} validateOnChange={true} validateOnBlur={true}>
          <Checkbox data-testid={'employer-modal-checkbox'} field={'protectInfoCheckbox'} label={`${t(EoiGeneralText.yes)}, ${customerName} ${t(EoiGeneralText.isMyCurrentEmployer)}`}/>
        </CheckboxGroup>
      </p>
      <p>{t(EoiGeneralText.notCurrentEmployer)}</p>
    </Modal>);
};
export default React.memo(EmployerConfirmationModal);
